import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";

import { COLOR_BLACK } from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { POPUP_CLASSES } from "./constants";

export const PopUpContainer = styled(Dialog)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  return {
    [`& .${POPUP_CLASSES.root}`]: {
      display: "flex",
      padding: theme.spacing(2),
      margin: 0,
      borderRadius: 0,
      alignSelf: "flex-end",
      width: "100%",
      [formatMedia.BREAKPOINT_TABLET]: {
        padding: theme.spacing(4),
        margin: theme.spacing(4),
        alignSelf: "center",
      },
    },
    [`& .${POPUP_CLASSES.title}`]: {
      padding: theme.spacing(0),
      marginTop: theme.spacing(5),
      [formatMedia.BREAKPOINT_TABLET]: {
        marginTop: "0",
      },
    },
    [`& .${POPUP_CLASSES.content}`]: {
      padding: 0,
      marginTop: theme.spacing(2),
    },
    [`& .${POPUP_CLASSES.description}`]: {
      color: COLOR_BLACK,
      marginBottom: 0,
    },
    [`& .${POPUP_CLASSES.closeButton}`]: {
      position: "absolute",
      top: theme.spacing(1),
      left: theme.spacing(1),
      [formatMedia.BREAKPOINT_TABLET]: {
        right: theme.spacing(1),
        left: "auto",
      },
    },
    [`& .${POPUP_CLASSES.actions}`]: {
      padding: 0,
      marginTop: theme.spacing(3),
      display: "flex",
      flexDirection: "column-reverse",
      [formatMedia.BREAKPOINT_TABLET]: {
        flexDirection: "row",
      },
    },
    [`& .${POPUP_CLASSES.actionButton}`]: {
      width: "100%",
      whiteSpace: "nowrap",
      "&:first-of-type": {
        marginTop: theme.spacing(2),
      },
      [formatMedia.BREAKPOINT_TABLET]: {
        width: "auto",
        "&:first-of-type": {
          marginRight: theme.spacing(2),
          marginTop: 0,
        },
      },
    },
    [`& .${POPUP_CLASSES.titleWithDisabledCloseButton}`]: {
      marginTop: 0,
    },
  };
});
